<div class="card" *ngIf="!isArray(legenda)">
    <div class="card-body">
      <div class="row">
        <ng-container>
          <div class="col-4"  *ngFor="let legenda of legenda?.legenda">
            <h4 class="card-title">{{legenda.area | translate}}</h4>
            <div>
              <span style="height: 10px;width: 10px;background-color: #bbb;border-radius: 50%;display: inline-block;"
                    [ngStyle]="{'background-color': legenda.color}"></span>
              &nbsp;
              <span class="text-dark">{{legenda.label | translate}}</span>
              <br>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
</div>
<div class="card" *ngIf="isArray(legenda)">
  <div class="card-body">
    <div class="row" *ngFor="let leg of legenda">
      <div class="col-12"><h4 class="card-title">{{leg.area | translate}}</h4></div>
        <div  class="col-3" *ngFor="let item of leg.legenda">
          <div >
            <span style="height: 10px;width: 10px;background-color: #bbb;border-radius: 50%;display: inline-block;"
              [ngStyle]="{'background-color': item.color}"></span>
            &nbsp;
            <span class="text-dark">{{item.label | translate}}</span>
          </div>
        </div>
    </div>
  </div>
</div>